import type { DiagnosticMatrix } from "../diagnostics/types";

import { generateRepairProposal } from "./repairProposalGenerator";

import { orderRepairProposals } from "./repairPrioritizer";

import type { RepairPlan } from "./types";

export class RepairPlanningService {
  createPlan(matrix: DiagnosticMatrix): RepairPlan {
    const proposals = matrix.findings.map((finding) =>
      generateRepairProposal(finding),
    );

    const orderedProposalIds = orderRepairProposals(proposals);

    return {
      proposals,
      orderedProposalIds,

      readyCount: proposals.filter((proposal) => proposal.status === "ready")
        .length,

      blockedCount: proposals.filter(
        (proposal) => proposal.status === "blocked",
      ).length,

      approvalRequiredCount: proposals.filter(
        (proposal) => proposal.status === "approval_required",
      ).length,
    };
  }
}
